import moment from 'moment';

export const materialTableFilterDate = (
  filter: string,
  timestamp: string,
  includeTime?: boolean
) => {
  const format = includeTime ? 'DD.MM.YYYY, hh:mm:ss' : 'DD.MM.YYYY';

  return moment(parseInt(timestamp))
    .format(format)
    .includes(filter);
};
